import React, { useState } from "react";
import "./../../styles/components/dashboard/filter-select.css";

function FilterSelect({ onFilter = () => {} }) {
  const [timeSelected, setTimeSelected] = useState("1month");

  const today = new Date();
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleChange = ({ target: { value } }) => {
    setTimeSelected(value);
    const datesRange = getDatesRange(value);
    const { startDate, endDate } = datesRange;
    onFilter(`startDate=${startDate}&endDate=${endDate}`);
  };

  const getDatesRange = (selectedFilter) => {
    let startDate = new Date();
    let endDate = new Date();
    switch (selectedFilter) {
      case "1day":
        startDate.setDate(today.getDate() - 1);
        break;
      case "1week":
        startDate.setDate(today.getDate() - 7);
        break;
      case "1month":
        startDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          today.getDate()
        );
        break;
      case "1year":
        startDate = new Date(
          today.getFullYear() - 1,
          today.getMonth(),
          today.getDate()
        );
        break;
      case "ytd":
        startDate = new Date(today.getFullYear(), 0, 1);
        break;
      case "1month":
        startDate = new Date(
          today.getFullYear(),
          today.getMonth() - 1,
          today.getDate()
        );
        break;
      case "3month":
        startDate = new Date(
          today.getFullYear(),
          today.getMonth() - 3,
          today.getDate()
        );
        break;
    }
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    };
  };

  const options = [
    {
      title: "1Day",
      value: "1day",
      default: false,
    },
    {
      title: "1Week",
      value: "1week",
      default: false,
    },
    {
      title: "Month",
      value: "1month",
      default: true,
    },
    {
      title: "YTD",
      value: "ytd",
      default: false,
    },
  ];

  return (
    <div className="component filter-select">
      <select value={timeSelected} onChange={handleChange}>
        {options.map((item) => (
          <option key={item.value} value={item.value}>
            {item.title}
          </option>
        ))}
      </select>
    </div>
  );
}

export default FilterSelect;
